import { Component, OnInit, Input } from '@angular/core';
import { Field } from '@ngx-formly/core';

@Component({
  selector: 'tr-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})

export class TaskComponent extends Field {

  @Input() name: string;
  @Input() duedate: string;
  @Input() taskstatus: number;
  @Input() gototask: Object;

  // getIco(action: stageTypes.IAction): string {
  //   if (_.has(action, 'iconclass')) {
  //     return action.iconclass;
  //   } else {
  //     return `ico-${action.name.toLowerCase()}`;
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/app/stage/components/task/task.component.ts